import controller from './invoices.controller';
import template from './invoices.html';

const taxationInvoicesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default taxationInvoicesComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/invoices/invoices.component.js
 **/